import { useCareerContext } from "@Context/game/career/career-context";
import useI18n from "@i18n";
import { Stack, Typography } from "@mui/material";
import CareerProgressChart from "./career-progress-chart";
import { CareerProgressPanel } from "./styled-components";

const CHART_HEIGHT = 0.75;
const TEXT_HEIGHT = 0.25;

const CareerStatusProgress = () => {
  const { i18n } = useI18n();
  const { nextLeague, remainingDivisions } = useCareerContext();

  return (
    <CareerProgressPanel>
      <Stack flex={CHART_HEIGHT} position="relative" width="100%" justifyContent="center" alignItems="center">
        <CareerProgressChart />
      </Stack>

      <Stack flex={TEXT_HEIGHT} justifyContent="center" alignItems="center" width="100%">
        {nextLeague && (
          <Typography variant="text1xl500" color="dsNeutral.v300" textAlign="center">
            {remainingDivisions > 0
              ? i18n("career.status.progress.base", {
                  divisions: remainingDivisions,
                  league: i18n(`league.${nextLeague.name}.short`),
                })
              : i18n("career.status.progress.last", {
                  league: i18n(`league.${nextLeague.name}.short`),
                })}
          </Typography>
        )}
      </Stack>
    </CareerProgressPanel>
  );
};

export default CareerStatusProgress;
